// src/pages/product.js
import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import { businessSchemaDE, businessSchemaEN } from "../schema";
import ProductDetail from "../components/shop/ProductDetail";
import instrumentsData from "../instrumente/instruments.js";

const Product = () => {
  const { i18n } = useTranslation();
  const { id } = useParams();
  const currentSchema =
    i18n.language === "en" ? businessSchemaEN : businessSchemaDE;

  // Find the product data to get its title
  const instrumentData = instrumentsData.find(
    (item) => item.id === parseInt(id)
  );

  // Get the product title based on the current language
  const productTitle = instrumentData
    ? i18n.language === "en"
      ? instrumentData.title_en
      : instrumentData.title_de
    : null;

  // Create the page title
  const pageTitle = productTitle
    ? i18n.language === "en"
      ? `${productTitle} - Violin Maker Jacobi`
      : `${productTitle} - Geigenbau Jacobi`
    : i18n.language === "en"
    ? "Product Details - Violin Maker Jacobi"
    : "Produktdetails - Geigenbau Jacobi";

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(currentSchema)}
        </script>
        <title>{pageTitle}</title>
        <meta
          name="description"
          content="Detaillierte Informationen zu unseren handgefertigten Geigen und Streichinstrumenten."
        />
        <meta
          name="keywords"
          content="Geigendetails, handgefertigte Geigen, Streichinstrumente, Spezifikationen"
        />
        <meta property="og:title" content="Produktdetails - Geigenbau Jacobi" />
        <meta
          property="og:description"
          content="Entdecken Sie die Details unserer hochwertigen handgefertigten Instrumente."
        />
      </Helmet>
      <div>
        <ProductDetail />
      </div>
    </>
  );
};

export default Product;
